"use client";

import { useState } from "react";
import "../assets/css/authpage.min.css";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { toast, ToastContainer } from 'react-toastify';
import TwoFactorAuthImage from './../assets/img/Mobile login-pana.svg';


export default function SignUp () {
    const [loginFormData, setLoginFormData] = useState({
        email: "",
        password: "",
    });

    const [signupFormData, setSignupFormData] = useState({
        username: "",
        mobile_no: "",
        email: "",
        password: "",
    });
    const navigate = useNavigate();


    const handleSignupFormSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("email", signupFormData.email);
        data.append("password", signupFormData.password);
        data.append("mobile_no", signupFormData.mobile_no);
        data.append("username", signupFormData.username);

        try {
            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_signup.php", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.status === "success") {
                navigate("/otp-varified");
                toast.success("signup successful!");
                Cookies.set('UserEmail', signupFormData.email, { expires: 7 }); // Expires in 7 days

                setSignupFormData({
                    username: "",
                    mobile_no: "",
                    email: "",
                    password: "",
                });
            } else {
                toast.error(result.message || "Login failed");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        }
    };


    const handleSignupInputChange = (e) => {
        setSignupFormData({
            ...signupFormData,
            [e.target.name]: e.target.value,
        });
    };




    return (
        <div className="auth-page-wrapper">
            <div className="flex-row">
                {/* Login Section - Left Side */}
                <div className="half-column ">
                    <img src={TwoFactorAuthImage} alt="log in page" style={{
                        height: "600px",
                        "@media (min-width: 992px)": {
                            marginLeft: "50px"
                        }
                    }} />

                </div>
                {/* Signup Section - Right Side */}
                <div className="half-column mt-5">
                    <div className="form-wrapper">
                        <div className="form-header mb-2">
                            <h2 >Create Account</h2>
                        </div>

                        <form onSubmit={handleSignupFormSubmit} className="auth-form">
                            <div className="input-group mb-2">
                                <label htmlFor="signupUsername" className="field-label">
                                    Username
                                </label>
                                <input
                                    type="text"
                                    id="signupUsername"
                                    name="username"
                                    className="input-field"
                                    placeholder="Choose a username"
                                    value={signupFormData.username}
                                    onChange={handleSignupInputChange}
                                    required
                                />
                            </div>

                            <div className="input-group mb-2">
                                <label htmlFor="signupMobile" className="field-label">
                                    Mobile Number
                                </label>
                                <input
                                    type="tel"
                                    id="signupMobile"
                                    name="mobile_no"
                                    className="input-field"
                                    placeholder="Enter your mobile number"
                                    value={signupFormData.mobile_no}
                                    onChange={handleSignupInputChange}
                                    required
                                />
                            </div>

                            <div className="input-group mb-2">
                                <label htmlFor="signupEmail" className="field-label">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    id="signupEmail"
                                    name="email"
                                    className="input-field"
                                    placeholder="Enter your email address"
                                    value={signupFormData.email}
                                    onChange={handleSignupInputChange}
                                    required
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="signupPassword" className="field-label">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="signupPassword"
                                    name="password"
                                    className="input-field"
                                    placeholder="Create a strong password"
                                    value={signupFormData.password}
                                    onChange={handleSignupInputChange}
                                    required
                                />
                            </div>

                            <button type="submit" className="btn-signin rounded-3 full-width">
                                Create Account
                            </button>
                            <p className="d-flex justify-content-center mt-3">Already have an account? <a href="/log-in"> Sign in</a></p>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
